import get from 'lodash/get';
import moment from 'moment';

export const getInvoices =
  ({ pageSize, pageNumber, sort, onSuccess = () => {} }) =>
  (dispatch, getState) => {
    const state = getState();
    const currentPageSize = get(state, 'invoices.invoices.size');
    const currentPageNumber = get(state, 'invoices.invoices.page');

    const params = {
      pageSize: pageSize || currentPageSize,
      pageNumber: pageNumber || currentPageNumber,
    };

    if (sort) {
      params.sort = sort.column;
      params.order = sort.order;
    }

    dispatch({
      type: 'GET_INVOICES',
      payload: {
        endpoint: 'api/v1/invoices',
        method: 'GET',
        params,
      },
      components: ['invoiceLoader'],
      onSuccess,
    });
  };

export const downloadInvoice = (objectId, invoiceId) => (dispatch) => {
  dispatch({
    type: 'DOWNLOAD_INVOICE',
    payload: {
      endpoint: `api/v1/invoices/download/${window.btoa(objectId)}`,
      method: 'GET',
      responseType: 'blob',
    },
    invoiceId,
  });
};

export const checkFSInvoice = () => (dispatch) => {
  dispatch({
    type: 'CHECK_FS_INVOICE',
    payload: {
      endpoint: 'api/v1/invoices/fs-check',
      method: 'GET',
    },
  });
};

export const generateInvoice =
  (data, onSuccess = () => {}, onError = () => {}) =>
  (dispatch) => {
    dispatch({
      type: 'GENERATE_INVOICE',
      payload: {
        endpoint: 'api/v1/invoices/generate',
        method: 'POST',
        body: data,
        responseType: 'blob',
      },
      onSuccess: (response) => {
        const blob = response;
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Invoice-${moment(data.createdAt).format('YYYY-MM-DD')}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        onSuccess(response);
      },
      onError,
    });
  };
